module.exports = __webpack_public_path__ + "static/1344525151-exit.11940b69.jpg";